import { useAppSelector } from 'appState/store'
import { exportBatch2, getDownloadBatch } from 'features/autocheck/autoCheckApi'
import { BatchStatus, IdownloadCSV } from 'features/autocheck/types'
import { updateDownloadNotifier } from 'features/claims/claimsSlice'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { FaRegBell } from 'react-icons/fa'
import { useDispatch } from 'react-redux'
import { NotificationDropDown } from '@outbound-ai/ursa'
import styled from 'styled-components'
import { downloadFile, getFileName } from 'utils/helper'
import { notificator } from 'utils/notificator/notificator'

export const BatchNotification = () => {
  const [batch, setBatch] = useState<any>([])
  const dispatch = useDispatch()
  const { downloadNotifier, triggerDownload } = useAppSelector((state) => state.claims)

  const fetchData = async () => {
    try {
      const res = await getDownloadBatch()
      setBatch(res.data)
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  const calculateDifference = () => {
    const oldRecord = JSON.parse(localStorage.getItem('batch') || '[]')
    const newRecord = batch
    if (oldRecord !== null && newRecord !== null) {
      const oldCompletedBatch = oldRecord.filter((item: any) => item.status === BatchStatus.Complete)
      const newCompletedBatch = newRecord.filter((item: any) => item.status === BatchStatus.Complete)
      if (oldCompletedBatch.length != newCompletedBatch.length) {
        dispatch(updateDownloadNotifier(true))
      } else {
        dispatch(updateDownloadNotifier(false))
      }
    }
  }

  useEffect(() => {
    const intervalId = setInterval(fetchData, 30000)
    return () => clearInterval(intervalId)
  }, [])

  useEffect(() => {
    fetchData()
  }, [triggerDownload])

  useEffect(() => {
    calculateDifference()
  }, [batch])

  const clearNotification = () => {
    localStorage.setItem('batch', JSON.stringify(batch))
    dispatch(updateDownloadNotifier(false))
  }

  const downloadBatchFile = (batchId: string) => {
    exportBatch2(batchId, 'filtered-claims').then((res) => {
      const downloadData: IdownloadCSV = {
        data: res.data,
        fileName: getFileName(res.headers),
        fileType: 'application/csv',
      }
      notificator.notify({
        heading: 'Download successful',
        message: `${getFileName(res.headers)} has been downloaded to your computer.`,
        type: 'success',
      })
      downloadFile(downloadData)
    })
  }

  const sortedbatchTime = batch.sort((a: any, b: any) => {
    return moment(b.created).diff(moment(a.created))
  })

  const groupedBatches = sortedbatchTime.reduce((acc: any, batch: any) => {
    const createdDate = moment(batch.created).local().format('MM/DD/YYYY')
    if (!acc[createdDate]) {
      acc[createdDate] = []
    }
    acc[createdDate].push(batch)
    return acc
  }, {})

  const sortedDates = Object.keys(groupedBatches).sort((a, b) => {
    return moment(b).diff(moment(a))
  })

  const dropdownItems = sortedDates.map((date) => ({
    title: moment(date).local().format('MM/DD/YYYY'),
    items: groupedBatches[date].map((item: any) => ({
      time: moment(item.created).format('hh:mm A'),
      status: item.status === BatchStatus.Complete ? false : true,
      text:
        item.status === BatchStatus.Complete
          ? 'Your claims file is ready to download  🎉'
          : item.status === BatchStatus.FailedToComplete
          ? 'Something went wrong 🧐'
          : 'Preparing claims file for download ⏳',
      filename:
        item.status === BatchStatus.Complete
          ? item.batchName
          : item.status === BatchStatus.FailedToComplete
          ? 'Please click “Download” again so we can prepare your claims file.'
          : 'We’ll notify you once your file is ready to download.',
      onClick: () => {
        downloadBatchFile(item.batchId)
      },
    })),
  }))

  return (
    <NotificationHolder>
      <Div>
        <NotificationDropDown
          buttonName={<FaRegBell />}
          radius="rounded"
          notifier={downloadNotifier}
          items={dropdownItems}
          onclick={() => {
            clearNotification()
          }}
        />
      </Div>
    </NotificationHolder>
  )
}

const NotificationHolder = styled.div`
  .alert {
    position: absolute;
    top: 60%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 9999;
  }
  p {
    margin-left: 1.3rem;
    ${({ theme }) => theme.colors.neutral.neutral};
  }
`

const Div = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  /* padding: 0rem 0.5rem; */
`
